import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b8115fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-container" }
const _hoisted_2 = { class: "message card text-bg-primary text-center m-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Limited support warning", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "button-row" }

import { onMounted, ref } from 'vue';

import Configuration from '@/helpers/Configuration';

const DISMISSED_KEY = 'dismissedMobileWarning';


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileWarning',
  setup(__props) {

const mobileWarningDialog = ref<HTMLDialogElement>();

function dismissWarning() {
    mobileWarningDialog.value!.close();
    localStorage.setItem(DISMISSED_KEY, 'true');
}

function isMobile() {
    const mobiles = /android|iphone|windows phone|kindle|webos|blackberry/;
    const ua = (navigator.userAgent || navigator.vendor).toLowerCase();
    return mobiles.test(ua) && !/ipad/.test(ua);
}

onMounted(() => {
    if (isMobile() && !localStorage.getItem(DISMISSED_KEY)) {
        mobileWarningDialog.value!.close();
        mobileWarningDialog.value!.showModal();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dialog", {
      ref_key: "mobileWarningDialog",
      ref: mobileWarningDialog
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("p", null, [
          _createTextVNode(" It seems you are using " + _toDisplayString(_unref(Configuration).APPLICATION_NAME) + " on a mobile device. ", 1),
          _hoisted_4,
          _createTextVNode(" This tool was designed for desktop usage and may not work correctly or perform well on mobile devices. ")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-primary text-light",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (dismissWarning()))
          }, " Ok, I understand ")
        ])
      ])
    ], 512)
  ]))
}
}

})